import { render, staticRenderFns } from "./verified-email.vue?vue&type=template&id=51295d1f&scoped=true&"
import script from "./verified-email.vue?vue&type=script&lang=js&"
export * from "./verified-email.vue?vue&type=script&lang=js&"
import style0 from "./verified-email.vue?vue&type=style&index=0&id=51295d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51295d1f",
  null
  
)

export default component.exports